<template>
  <svg
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 18 18"
    aria-hidden="true"
  >
    <path
      d="M14.69 4.3a1 1 0 111-1 1 1 0 01-1 1zM9 14a5 5 0 115-5 5 5 0 01-5 5zm5-14H4a4 4 0 00-4 4v10a4 4 0 004 4h10a4 4 0 004-4V4a4 4 0 00-4-4zM9 6.05A3 3 0 1012 9a2.95 2.95 0 00-3-2.95z"
    />
  </svg>
</template>
